"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Adornment = void 0;
var react_1 = __importDefault(require("react"));
var css_1 = require("@emotion/css");
var adornmentStyles = (0, css_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 4px;\n"], ["\n  padding: 4px;\n"])));
var Adornment = function (_a) {
    var _b;
    var testId = _a.testId, render = _a.render, position = _a.position, additionalStyles = _a.additionalStyles;
    if (!render) {
        return null;
    }
    var adornmentTestId;
    if (testId) {
        adornmentTestId = position == 'start' ? "".concat(testId, "-start-adornment") : "".concat(testId, "-end-adornment");
    }
    return react_1.default.cloneElement(render, {
        className: (0, css_1.cx)(adornmentStyles, (_b = render.props) === null || _b === void 0 ? void 0 : _b.className, additionalStyles),
        'data-testid': adornmentTestId,
    });
};
exports.Adornment = Adornment;
var templateObject_1;
